import React from "react";
import {
    Box,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Table
} from '@material-ui/core';
export default class ComponentToPrint extends React.Component {
    render() {
        const StockBalanceDetails = this.props.StockBalanceDetails;
        const SearchData = this.props.SearchData;
        const StockBalanceReportInput = this.props.StockBalanceReportInput;
        return (
            <div>
                <h2><center><u>Available GRN Report</u></center></h2>
                <div>&nbsp;</div>
                <h2><center>{SearchData.groupName} - {SearchData.factoryName}</center></h2>
                <h3><center>Item Category:{SearchData.itemCategoryName == undefined ? 'All Item Category' : SearchData.itemCategoryName}</center></h3>
                <h3><center>Factory Item: {SearchData.factoryItemName == undefined ? 'All Factory Item' : SearchData.factoryItemName}</center></h3>
                <div>&nbsp;</div>
                <h2><center>{StockBalanceReportInput.date}</center></h2>
                <div>
                    <Box maxWidth={1100}>
                        <TableContainer >
                            <Table aria-label="caption table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={{ border: "1px black solid" }} align={'left'}>Item Category</TableCell>
                                        <TableCell style={{ border: "1px black solid" }} align={'left'}>Factory Item</TableCell>
                                        <TableCell style={{ border: "1px black solid" }} align={'left'}>GRN Number</TableCell>
                                        <TableCell style={{ border: "1px black solid" }} align={'left'}>Supplier</TableCell>
                                        <TableCell style={{ border: "1px black solid" }} align={'right'}>Quantity</TableCell>
                                        <TableCell style={{ border: "1px black solid" }} align={'right'}>Unit Price (LKR)</TableCell>
                                        <TableCell style={{ border: "1px black solid" }} align={'right'}>Total Price (LKR)</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {StockBalanceDetails.map((data, index) => (
                                        <TableRow key={index}>
                                            <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid black", fontSize: "12px", padding: '5px' }}>
                                                {data.categoryName}
                                            </TableCell>
                                            <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid black", fontSize: "12px", padding: '5px' }}>
                                                {data.itemName}
                                            </TableCell>
                                            <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid black", fontSize: "12px", padding: '5px' }}>
                                                {data.grnNumber}
                                            </TableCell>
                                            <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid black", fontSize: "12px", padding: '5px' }}>
                                                {data.supplierName}
                                            </TableCell>
                                            <TableCell align={'right'} component="th" scope="row" style={{ border: "1px solid black", fontSize: "12px", padding: '5px' }}>
                                                {data.quantity}
                                            </TableCell>
                                            <TableCell align={'right'} component="th" scope="row" style={{ border: "1px solid black", fontSize: "12px", padding: '5px' }}>
                                                {data.unitPrice.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                            </TableCell>
                                            <TableCell align={'right'} component="th" scope="row" style={{ border: "1px solid black", fontSize: "12px", padding: '5px' }}>
                                                {(data.quantity * data.unitPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </div>
                <div>&nbsp;</div>
                <h3><center>***** End of List *****</center></h3>
            </div>
        );

    }

}